import Vue from 'vue'
import {
  ConfigProvider,
  Row,
  Col,
  Checkbox,
  Button,
  Modal,
  Alert,
  Steps,
  Card,
  Radio,
  Input,
  List,
  Popover,
  Divider,
  FormModel,
  Transfer,
  Icon,
  InputNumber,
  Badge,
  Spin,
  Timeline,
  Tree,
  Empty,
  Collapse,
  Descriptions,
  Tooltip,
  AutoComplete,
  Select,
  Switch,
  Dropdown,
  Menu
} from 'ant-design-vue'

Vue.use(ConfigProvider)
  .use(Row)
  .use(Col)
  .use(Checkbox)
  .use(Button)
  .use(Modal)
  .use(Alert)
  .use(Steps)
  .use(Card)
  .use(Radio)
  .use(Input)
  .use(List)
  .use(Popover)
  .use(Divider)
  .use(FormModel)
  .use(Transfer)
  .use(Icon)
  .use(InputNumber)
  .use(Badge)
  .use(Spin)
  .use(Timeline)
  .use(Tree)
  .use(Tooltip)
  .use(Empty)
  .use(Collapse)
  .use(Descriptions)
  .use(AutoComplete)
  .use(Select)
  .use(Switch)
  .use(Dropdown)
  .use(Menu)

Vue.prototype.$antConfirm = Modal.confirm
Vue.prototype.$antError = Modal.error
Vue.prototype.$antInfo = Modal.info
Vue.prototype.$antWarning = Modal.warning
Vue.prototype.$antModalDestroyAll = Modal.destroyAll
